import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthyService {

  // private API_URL_GET_INFO_USER = environment.api_main + 'user'

  private API_SEND_PUSH = environment.api_main + 'auth/send';
  private API_CHECK_STATUS = environment.api_main + 'auth/check/';


  localStatus = {'status':false};

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient) {
    this.localStatus = (this.getLocalStatus())? this.getLocalStatus():{'status':false};
  }




  async get(PUSH_UUID){
    return await this.http.get(this.API_CHECK_STATUS + PUSH_UUID, this.httpOptions).toPromise();
  }

  async post(AUTHY_ID){
    return await this.http.post(this.API_SEND_PUSH, {'authyId': `${AUTHY_ID}`}, this.httpOptions).toPromise();
  }

  getLocalStatus() {
    return JSON.parse(localStorage.getItem('localStatus'));
  }
  setLocalStatus(obj: any) {
    localStorage.setItem('localStatus', JSON.stringify(obj));
    this.localStatus = (this.getLocalStatus())? this.getLocalStatus():{'status':false};
  }
  removeLocalStatus() {
    localStorage.removeItem('localStatus');
    this.localStatus = (this.getLocalStatus())? this.getLocalStatus():{'status':false};
  }
}
